<div class="modal-header">
  <h4 class="modal-title" style="color: red;" *ngIf="notify.status == 'Failure'">{{notify.status}}</h4>
  <h4 class="modal-title" *ngIf="notify.status != 'Failure'">{{notify.status}}</h4>
</div>
<div class="modal-body">
  <p style="color: red;" *ngIf="notify.status == 'Failure'">{{notify.message}}!</p>
  <p *ngIf="notify.status != 'Failure'">{{notify.message}}!</p>
</div>